// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlEntitiesList: [
    { name: "Sedes electrónicas", url: "https://aws.www.gov.co/biblioteca/recurso/integro/sedes-electr%C3%B3nicas-/dos/11" },
    { name: "Trámites y servicios", url: "https://aws.www.gov.co/biblioteca/recurso/integro/tr%C3%A1mites-y-servicios/dos/5" },
    { name: "Ventanillas únicas", url: "https://aws.www.gov.co/biblioteca/recurso/integro/ventanillas-%C3%BAnicas/dos/15" },
    { name: "Portales transversales", url: "https://aws.www.gov.co/biblioteca/recurso/integro/portales-transversales/dos/16" },
    { name: "Interoperabilidad", url: "https://aws.www.gov.co/biblioteca/recurso/integro/interoperabilidad/dos/34" },
    { name: "Autenticación Digital", url: "https://aws.www.gov.co/biblioteca/recurso/integro/autenticaci%C3%B3n-digital/dos/32" }
    ],
  repositoryCode: {
    urlBase: "https://gitlab.com/govco-developers/layout-govco",
    pathBranch: "/-/blob/develop/"
  },
  cdnVersions: {
    v1: "https://aws-cdn.www.gov.co/",
    v2: "https://aws-cdn.www.gov.co/v2/",
    v3: "https://aws-cdn.www.gov.co/v3/",
  },
  cdnUrl: "https://aws-cdn.www.gov.co/layout/v4/",
  homeUrl: 'https://aws.www.gov.co/',
  carpetaciudadanaUrl: 'https://precarpetaciudadana.and.gov.co/',
  tramitesUrl: 'https://aws.www.gov.co/ficha-tramites-y-servicios/codigos-ciiu-y-tramites',
  fuenteIconografica: 'https://gitlab.com/govco-developers/layout-govco/-/blob/develop/src/assets/icons/fonts/govco-font-icons.ttf',
  govco: 'https://aws.www.gov.co/',
  pathBranchIcon: '/-/raw/develop/src/assets/icons/',
  imagesUrl: 'https://aws-cdn.www.gov.co/v4/assets/images/',
  urlPlanIntegracion: "https://preadmin.www.gov.co/Autenticacion/Autenticacion/RegistroAutoridad",
  urlBiblioteca: "https://aws.www.gov.co/biblioteca/",
  urlCajadeHerramientas: "https://aws.www.gov.co/caja-de-herramientas",
  imageinRepository: "https://aws-cdn.www.gov.co/v4/assets/images/"
};


